<hc-modal>
    <hc-modal-header>
        <div class="detail-header">
            <span> <span class="icon-user-circle icon-left"></span>{{ userInfo?.name }}</span>
            <span class="header-sub-title">{{ userInfo?.preferred_username }}</span>
        </div>
    </hc-modal-header>
    <hc-tab-set direction="horizontal" [selectedTab]="0">
        <hc-tab tabTitle="User Detail">
            <div class="detail-tab-content">
                <table class="hc-table">
                    <thead>
                        <tr>
                            <th>Preferred Username</th>
                            <th>Location</th>
                            <th>Tenant</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>{{ userInfo?.preferred_username }}</td>
                            <td>{{ userInfo?.location }}</td>
                            <td>{{ userInfo?.tenant_id }}</td>
                        </tr>
                    </tbody>
                </table>

                <table class="hc-table">
                    <thead>
                        <tr>
                            <th>Email</th>
                            <th>Last Login</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>{{ userInfo?.email }}</td>
                            <td>{{ userInfo?.last_login }}</td>
                        </tr>
                    </tbody>
                </table>
                <div class="roles-content">
                    <div>Groups ({{ userInfo?.roles.length }})</div>
                    <div class="roles-list-outer">
                        <ul class="roles-list">
                            <li *ngFor="let role of userInfo?.roles">{{ role }}</li>
                        </ul>
                    </div>
                </div>
            </div>
        </hc-tab>
        <hc-tab tabTitle="Raw Token">
            <div class="token-tab-content">
                <pre><code>{{ userInfo | json }}</code></pre>
            </div>
        </hc-tab>
    </hc-tab-set>
    <hc-modal-footer> <button hc-button buttonStyle="primary" (click)="close()">Done</button></hc-modal-footer>
</hc-modal>
